import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'

import {
  BANNER_PLACEMENT,
  DEAL_FREEZE_EDUCATION_BANNER_SENTINEL
} from './constants'
import {DealFreezeEducationBannerContent} from './DealFreezeEducationBannerContent'
import {useDealFreezeEducationBanner} from './useDealFreezeEducationBanner'

import type {DealFreezeEducationBannerPlacement} from './constants'

interface Props {
  slot: DealFreezeEducationBannerPlacement
}

export const DealFreezeEducationBanner: React.FC<Props> = ({slot}) => {
  const {isVisible, isReadyToTrigger, inViewRef, dismiss, onCtaClick} =
    useDealFreezeEducationBanner(slot)

  if (isVisible) {
    return (
      <Box paddingBottom="s500">
        <DealFreezeEducationBannerContent
          onCtaClick={onCtaClick}
          onClose={slot === BANNER_PLACEMENT.primary ? dismiss : undefined}
        />
      </Box>
    )
  }

  if (isReadyToTrigger) {
    return (
      <div
        ref={inViewRef}
        aria-hidden
        data-id={DEAL_FREEZE_EDUCATION_BANNER_SENTINEL}
      />
    )
  }

  return null
}
